
import Vue from 'vue';
import { BInputGroup, BInputGroupPrepend } from 'bootstrap-vue';
import { TuxInputText } from '../..';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default Vue.extend({
	name: 'TreeView',
	components: {
		BInputGroup,
		BInputGroupPrepend,
		TuxInputText,
		FontAwesomeIcon
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		showCollapseAll: {
			type: Boolean,
			required: false,
			default: null
		},
		searchBoxClass: {
			type: String,
			required: false,
			default: ''
		},
		value: {
			type: String,
			required: true,
			default: null
		}
	},
	data() {
		return {
			isExpanded: false as boolean
		};
	},
	methods: {
		toggleExpanded(): void {
			this.isExpanded = !this.isExpanded;
			this.$emit('expand-clicked', this.isExpanded);
		},
		emitValue(newValue: string): void {
			this.$emit('input', newValue);
		}
	}
});
